module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_9016.859b1c9e.png";